import client from './SharedConfig';

export const createAgencyAd = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/dashboard/agency/create/',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const getUserAgencies = ({header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/user/agencies/list/',
        headers: header
    };
    return client.request(config )
};

export const getAgencyCompaniesList = ({header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/company/list/',
        headers: header
    };
    return client.request(config )
};

export const getAgenciesList = ({parameter={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/agency/list/',
        params: parameter
    };
    return client.request(config )
};

export const getAgencyDetails = (id = "0") => {
    const config = {
        method: 'GET',
        url: `advertisement/agency/detail/${id}/`
    };
    return client.request(config)
};

export const deleteAgency = ({header={}} = {}, id=0) => {
    const config = {
        method: 'DELETE',
        url: `advertisement/dashboard/agency/delete/${id}/`,
        headers: header
    };
    return client.request(config)
};

export const getAgencyAds = ({parameter={}, id="0"} = {}) => {
    const config = {
        method: 'GET',
        url: `advertisement/agency/ads/list/${id}/`,
        params: parameter
    };
    return client.request(config )
};

export const getAgencyStatistics = () => {
    const config = {
        method: 'GET',
        url: `advertisement/agency/statistics/`
    };
    return client.request(config)
};

export const elevateAgency = ({header={}} = {}, id=0) => {
    const config = {
        method: 'POST',
        url: `advertisement/dashboard/agency/elevate/${id}/`,
        headers: header
    };
    return client.request(config )
};